export const DCIMPORT_FILECONFIG_SAVE_FILE = 'DCIMPORT_FILECONFIG_SAVE_FILE';
export const DC_IMPORT_FETCHING = 'DC_IMPORT_FETCHING';
export const DC_IMPORT_FETCH_ERROR = 'DC_IMPORT_FETCH_ERROR';
export const DC_IMPORT_SAVE_FILE_CONFIG = 'DC_IMPORT_SAVE_FILE_CONFIG';
export const DC_IMPORT_SAVE_SELECTED_CONFIG = 'DC_IMPORT_SAVE_SELECTED_CONFIG';
export const DC_IMPORT_SAVE_CONFIG_NAME = 'DC_IMPORT_SAVE_CONFIG_NAME';
export const DC_IMPORT_SAVE_SELECTED_CONFIG_ID =
  'DC_IMPORT_SAVE_SELECTED_CONFIG_ID';



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/common/types.js